import { envs } from "../evns";

export function request({ url, data, method = "post", reslove, reject, portalToken, timeoutCb }) {
    const xhr = new XMLHttpRequest()
    xhr.open(method, envs.baseUrl + url);
    xhr.timeout = 100000;
    xhr.setRequestHeader('content-type', ' application/json;charset=UTF-8');
    xhr.setRequestHeader('accept-language', 'zh-CN,zh;q=0.9');
    xhr.setRequestHeader('accept', 'application/json, text/plain, */*');
    portalToken && xhr.setRequestHeader('portal-token', portalToken);
    switch (method) {
        case "get":
            xhr.send(null)
            break;
        case "post":
            xhr.send(JSON.stringify(data));
            break;
    }
    xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
            switch (xhr.status) {
                case 200:
                    if(xhr.response){
                        const res = JSON.parse(xhr.response)
                        reslove(res)
                    }
                    break;
                default:
                    timeoutCb && timeoutCb()
            }

        }
    }
    xhr.ontimeout = () => {
        timeoutCb && timeoutCb()
    };
}